import clsx from "clsx";
import { type ComponentPropsWithRef, createElement } from "react";
import styles from "./style.module.scss";

type Size = "small" | "medium" | "large";
type Tag = "p" | "span" | "li";
type Props<T extends Tag> = {
	tag?: T;
	size?: Size;
	bold?: boolean;
} & ComponentPropsWithRef<T>;

export function Typography<T extends Tag>({
	tag,
	className,
	children,
	size = "small",
	bold,
	...props
}: Props<T>) {
	return createElement(
		tag || "p",
		{
			className: clsx(
				styles.typography,
				styles[size],
				bold && styles.bold,
				className,
			),
			...props,
		},
		children,
	);
}
